import { getRegisterFunction } from '../../utils/register.js';
import { OneUxDashboardElement } from './OneUxDashboardElement.js';
export const register = getRegisterFunction(OneUxDashboardElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-dashboard': OneUxDashboardElement;
    "dashboard-7a3509c8ca822a46570e7a373ed264be": OneUxDashboardElement;
  }
}